import React from 'react';
import {  Col, Row, FormCheck } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TitleLayer(props) {

    return(
        <Row>
            <Col lg={2} xs={2}>
                <FontAwesomeIcon icon={['fas', "grip-lines"]} />
            </Col>
            <Col lg={7} xs={7}>
                <p>{props.layer.title}</p>
            </Col>
            <Col lg={3} xs={3}>
                <FormCheck
                    id={props.layer.name}
                    type="switch"
                    label=""
                    onChange={() => {
                        props.handleTitleCadastreLoad(props.layer);
                    }}
                />
            </Col>
        </Row>
    );
}